if (!customElements.get("product-bowl")) {
  class ComponentBowl extends HTMLElement {
    constructor() {
      super();

      this.addOnElement = this.querySelectorAll(".add-on");
      this.checkboxs = this.querySelectorAll("input[type=checkbox]");
      this.btnsAdd = this.querySelectorAll(".btn-add");
      this.variants = this.querySelectorAll(".variants .swatch input[type=radio]");
      
      this.initCheckboxs();
      this.initVariants();
      
      // pre-select first variant
      this.addOnElement.forEach((card) => {
        const items = card.querySelectorAll(".variants .swatch input[type=radio]");
        const firstInput = items[0];
        if (firstInput) {
          firstInput.dispatchEvent(new Event("change", { bubbles: true }));
          const label = card.querySelector(`label[for="${firstInput.id}"]`);
          label?.classList.add("active");
        }
      });

      this.totalPrice();
      this.addProducts();
    }

    subscriptionPrice(addOnElement) {
      const subscriptionSelect = addOnElement.querySelector('.subscription-option');
      if(subscriptionSelect){
        subscriptionSelect.addEventListener("change", (event) => {
          const selectedOption = event.target.options[event.target.selectedIndex];
          const price = selectedOption.dataset.price;
          const compareAtPrice = selectedOption.dataset.compareAtPrice; 
          this.updatePriceCard(addOnElement, price, compareAtPrice);
        });
      }
    }

    updatePriceCard(addOnElement, price, compareAtPrice){
      const card = addOnElement.querySelector('.product-price');
      
      const enableUtmDiscount = card.dataset.enableUtmDiscount === 'true';
      const utmApplyDiscount = window.UTMDiscount ? window.UTMDiscount.getDiscountApplicable(addOnElement.dataset.productCollections) : false;
      const utmDiscountAmount = window.UTMDiscount ? window.UTMDiscount.getCardDiscountAmount(addOnElement.dataset.productCollections) : 0;
      if (enableUtmDiscount && utmApplyDiscount && utmDiscountAmount > 0) {
        var newPrice = window.UTMDiscount.applyDiscount(Math.round(price * 100), utmDiscountAmount) / 100;
      }else{
        var newPrice = price * 1;
      }
      var newCompareAtPrice = compareAtPrice * 1;

      card.dataset.price = Math.round(newPrice * 100);

      card.innerHTML = `<span class="compare">$${newCompareAtPrice.toFixed(2)}</span><span class="final price-field">$${newPrice.toFixed(2)}<span>`;
      this.totalPrice();
    }


    initVariants() {
      this.variants.forEach((variant) => {
        
        variant.addEventListener("change", (event) => {
          const addOnElement = event.currentTarget.closest(".add-on");
          const selectedOption = event.currentTarget;
          const newVariantId = selectedOption.value;
          const price = selectedOption.dataset.price;
          const image = selectedOption.dataset.image;

          if (addOnElement) {
            
            // deselect variant
            const productCard = variant.closest('.product-card');
            productCard.querySelectorAll('.swatch label').forEach(label => {
              label.classList.remove("active");
            });
            
            // Select current variant
            const selectedLabel = event.target.closest('label');
            if (selectedLabel) {
              selectedLabel.classList.add("active");
            }

            addOnElement.setAttribute("data-product", newVariantId);

            // update ProductCard
            const priceElement = addOnElement.querySelector(".product-price");
            if (priceElement)
              priceElement.textContent = `$${parseFloat(price).toFixed(2)}`;
            
            // Update Image
            const imageElement = addOnElement.querySelector("img");
            if (imageElement && image){
              imageElement.removeAttribute("data-srcset");
              imageElement.removeAttribute("data-src");
              imageElement.removeAttribute("srcset");
              imageElement.src = image;
            }

            this.renderSubscriptionOptionsFromData(addOnElement, selectedOption);
            
            // pre-select first option
            const select = addOnElement.querySelector(".subscription-option");
            if (select && select.options.length > 0) {
              select.selectedIndex = 0;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }

          }
        });
      });
    }

    renderSubscriptionOptionsFromData(addOnElement, selectedVariantInput) {
      let wrapper = addOnElement.querySelector('.subscription-options');
      const raw = selectedVariantInput ? selectedVariantInput.dataset.sellingPlans : null;
      let plans = [];
      if (raw) {
        try {
          plans = JSON.parse(raw);
          if (!Array.isArray(plans)) plans = [];
        } catch (e) {
          console.warn('Error data-selling-plans', e, raw);
          plans = [];
        }
      }
      
      const nodes = [];

      // SUBSCRIPTION
      if (plans && plans.length > 0) {
        nodes.push('<select class="subscription-option" name="subscription-option">');
        plans.forEach(plan => {
          const planId = plan.id || plan.selling_plan_id || plan.plan_id || JSON.stringify(plan);
          let planLabel = plan.name;
          nodes.push(`<option data-price="${plan.price}" data-compare-at-price="${plan.compare_at_price}" value="${planId}">
            ${planLabel}
          </option>`);
        });
        nodes.push('</select>');
      }
      wrapper.innerHTML = nodes.join('');      

      // update Prices
      if (plans && plans.length > 0) {
        this.subscriptionPrice(addOnElement);
      }
    }


    totalPrice() {
      let totalPrice = 0;
      this.addOnElement.forEach((product) => {
        if (!product.classList.contains("disabled")) {
          const price = parseFloat(product.querySelector(".product-price").dataset.price);
          if (!isNaN(price)) {
            totalPrice += price;
          }
        }
      });
      this.querySelector('.total-price span').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
    }

    initCheckboxs() {
      this.checkboxs.forEach((checkbox) => {
        checkbox.addEventListener("change", (event) => {
          const addOnElement = event.currentTarget.closest(".add-on");
          if(event.target.checked){
            addOnElement.classList.remove("disabled");
          } else {
            addOnElement.classList.add("disabled");
          }
          this.totalPrice();
        });
      });
    }

    initSelects() {
      this.variants.forEach((variant) => {
        variant.addEventListener("change", (event) => {

          const addOnElement = event.currentTarget.closest(".add-on");
          const selectedOption = event.currentTarget.selectedOptions[0];
          const newVariantId = event.currentTarget.value;
          const price = selectedOption.dataset.price;
          const image = selectedOption.dataset.image;

          if (addOnElement) {
            addOnElement.setAttribute("data-product", newVariantId);

            // update ProductCard
            const priceElement = addOnElement.querySelector(".product-price");
            if (priceElement) {
              priceElement.textContent = `$${parseFloat(price).toFixed(2)}`;
              priceElement.setAttribute("data-price", Math.round(price * 100));
            }

            const imageElement = addOnElement.querySelector("img");
            if (imageElement && image){
              imageElement.removeAttribute("data-srcset");
              imageElement.removeAttribute("data-src");
              imageElement.removeAttribute("srcset");
              imageElement.src = image;
            }

            this.totalPrice();
          }
        });
      });
    }

    addProducts() {
      const btnAdd = this.querySelector(".actions .btn-add");
      btnAdd.addEventListener("click", (event) => {
        event.preventDefault();
        $s.showLoadingOverlay();
        
        const itemsToAdd = [];
        this.addOnElement.forEach((item) => { 
          if (!item.classList.contains("disabled")) {

            const productId = parseInt(item.dataset.product);
            const quantity = 1;

            const select = item.querySelector('select[name="subscription-option"]');
            const sellingPlanId = select?.value;

            if (!isNaN(productId)) {
              const itemData = { id: productId, quantity };
              if (sellingPlanId) 
                itemData.selling_plan = parseInt(sellingPlanId);
              
              itemsToAdd.push(itemData);
            }
          }
        });
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(response => response.json())
        .then(data => {
          $s.hideLoadingOverlay();
          $s.addToCartSuccess();
        })
        .catch(error => {
          $s.hideLoadingOverlay();
        });
      });
    }

  }
  customElements.define("product-bowl", ComponentBowl);
}
